<template>
<div>
  <form-row name="name" :value="widget.name || old.name || ''" type="text" :display='t.fields.name'
            :error='errors.name'></form-row>
  <form-row name="description" :value="widget.description || old.description || ''" type="textarea" :display="t.fields.description"
            :error="errors.name"></form-row>
  <form-row name="display" :value="widget.display || old.display || ''" type="text" :display='t.fields.display'
            :error='errors.display'></form-row>
  <form-row name="type" v-model="type" type="select" :display='t.fields.type'
            :options='typeOptions'
            :error='errors.type'></form-row>
  <template v-for="(settings, key) in configurationOptions[type] || []">
    <form-row v-if="settings.type === 'timestamp'"
              type="date"
              :name="`parameters[${key}]`"
              :value="widget.parameters[key] || old[key] || ''"
              :display='t.fields[key]'
              :error='errors[key]'></form-row>

    <form-row v-if="settings.type === 'interval'"
              :name="`parameters[${key}]`"
              :value="widget.parameters[key]"
              type="select"
              :display='t.fields[key]'
              :options='intervalOptions'
              :error='errors[key]'></form-row>

    <form-row v-if="settings.type === 'select'"
              :name="`parameters[${key}]${(settings.multiple ? '[]' : '')}`"
              :value="widget.parameters[key] || old[key]"
              type="select"
              :multiple="settings.multiple"
              :display='t.fields[key]'
              :options='Object.entries(settings.options).map(([k, v]) => ({value: k, display: v}))'
              :error='errors[key]'></form-row>

    <form-row v-if="settings.type === 'number'"
              :name="`parameters[${key}]`"
              :value="widget.parameters[key] || old[key]"
              type="number"
              :display="t.fields[key]"
              :error="errors[key]"></form-row>
  </template>
</div>
</template>

<script>

function object_get(o, k) {
  return k.split('.').reduce((acc, cur) => acc instanceof Object && cur in acc ? acc[cur] : null, o)
}

export default {
  props: ['t', 'widget', 'old', 'errors', 'configurationOptions'],
  data() {
    return {
      type: this.old.type || this.widget.type,
    }
  },
  methods: {
    makeOption(prefix, value) {
      return {value, display: object_get(this.t, `${prefix}.${value.toLowerCase()}`) || `${prefix}.${value.toLowerCase()}`}
    }
  },
  computed: {
    typeOptions() {
      return Object.keys(this.configurationOptions)
        .map(this.makeOption.bind(this, 'values.type'))
    },
    intervalOptions() {
      return ['P1D', 'P7D', 'P1M', 'P6M', 'P1Y']
        .map(this.makeOption.bind(this, 'values.interval'))
    },
  },
  mounted() {
    console.log(this.errors, this.widget)
  }
}
</script>
